import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetAgreementDocument } from '../hooks/useGetAgreementDocument';
import { checkNeedLoginPath } from 'views/constants/enums/pageTitle';

export const useAgreementDocumentModal = () => {
  const [isOpenAgreementModal, setIsOpenAgreementModal] = useState<boolean>(false);
  const { agreementDocument, getAgreementDocument } = useGetAgreementDocument({});

  const location = useLocation();

  useEffect(() => {
    if (checkNeedLoginPath(location.pathname)) {
      getAgreementDocument();
    }
  }, [location]);

  useEffect(() => {
    if (agreementDocument.fetching) return;
    if (!agreementDocument.data?.GetAgreementDocument?.Data) return;
    const data = agreementDocument.data.GetAgreementDocument.Data;
    const isRead = data.some((d) => d?.Read === false);
    if (isRead) {
      setIsOpenAgreementModal(true);
    }
  }, [agreementDocument]);

  return {
    agreementDocument,
    isOpenAgreementModal,
    setIsOpenAgreementModal,
  };
};
